import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-profile-info"
}
const _hoisted_2 = { class: "user-profile-info__name" }
const _hoisted_3 = { class: "user-profile-info__value" }
const _hoisted_4 = { class: "sidebar-scrollable" }
const _hoisted_5 = { class: "sidebar-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterStatus = _resolveComponent("FilterStatus")!
  const _component_FilterType = _resolveComponent("FilterType")!
  const _component_FilterCategory = _resolveComponent("FilterCategory")!
  const _component_FilterSource = _resolveComponent("FilterSource")!
  const _component_FilterRegion = _resolveComponent("FilterRegion")!
  const _component_FilterCompany = _resolveComponent("FilterCompany")!
  const _component_FilterPrice = _resolveComponent("FilterPrice")!
  const _component_FilterStartDate = _resolveComponent("FilterStartDate")!
  const _component_FilterEndDate = _resolveComponent("FilterEndDate")!
  const _component_ButtonApplyFilters = _resolveComponent("ButtonApplyFilters")!
  const _component_ButtonSaveTemplate = _resolveComponent("ButtonSaveTemplate")!
  const _component_ButtonDeleteTemplate = _resolveComponent("ButtonDeleteTemplate")!
  const _component_ButtonResetFilters = _resolveComponent("ButtonResetFilters")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["sidebar js-sidebar", {
      'sidebar-wrapper-procedures': ['tenderSerp', 'company', 'sourceSerp', 'typeSerp', 'regionSerp', 'categorySerp'].includes(_ctx.currentRoute),
      'sidebar-wrapper-favourites': _ctx.currentRoute === 'favourites'
    }])
  }, [
    (_ctx.company && _ctx.currentRoute === 'company')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.company.tin), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.company.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: _normalizeClass(["filter-form", {'no-notification-button': _ctx.currentRoute === 'favourites'}])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FilterStatus),
        _createVNode(_component_FilterType),
        _createVNode(_component_FilterCategory),
        _createVNode(_component_FilterSource),
        _createVNode(_component_FilterRegion),
        (_ctx.currentRoute !== 'company')
          ? (_openBlock(), _createBlock(_component_FilterCompany, {
              key: 0,
              onApplyFilters: _ctx.applyFilters
            }, null, 8, ["onApplyFilters"]))
          : _createCommentVNode("", true),
        _createVNode(_component_FilterPrice, { onApplyFilters: _ctx.applyFilters }, null, 8, ["onApplyFilters"]),
        _createVNode(_component_FilterStartDate, { onApplyFilters: _ctx.applyFilters }, null, 8, ["onApplyFilters"]),
        _createVNode(_component_FilterEndDate, { onApplyFilters: _ctx.applyFilters }, null, 8, ["onApplyFilters"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.showApplyButton)
          ? (_openBlock(), _createBlock(_component_ButtonApplyFilters, {
              key: 0,
              onApplyFilters: _ctx.applyFilters
            }, null, 8, ["onApplyFilters"]))
          : _createCommentVNode("", true),
        (_ctx.showSubscribeButton)
          ? (_openBlock(), _createBlock(_component_ButtonSaveTemplate, {
              key: 1,
              onSaveTemplate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveTemplate({ 
            query: _ctx.query, 
            filters: { ..._ctx.filters }, 
            notificationMessage: _ctx.$t('notifications.add_template') 
          })))
            }))
          : _createCommentVNode("", true),
        (_ctx.showUnsubscribeButton)
          ? (_openBlock(), _createBlock(_component_ButtonDeleteTemplate, {
              key: 2,
              onDeleteTemplate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteTemplate({
            templateId: _ctx.templateExists, 
            notificationMessage: _ctx.$t('notifications.delete_template')
          })))
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ButtonResetFilters, { onResetFilters: _ctx.resetFilters }, null, 8, ["onResetFilters"])
      ])
    ], 2)
  ], 2))
}